import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlContainer,
  FormArray,
  FormGroupDirective,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SelectBox, TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import {
  Sgke141aResponseInitialhyojiInfo,
  Sgke142aResponseGamenHyojiInfo,
  Sgke142aResponseInitialhyojiInfo,
} from 'sg-api';

@Component({
  selector: 'app-sgke140d-info',
  templateUrl: './sgke140d-info.component.html',
  styleUrl: './sgke140d-info.component.scss',
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class Sgke140dInfoComponent implements OnInit, OnDestroy {
  /** モーダル表示フラグ */
  @Input() isMordal: boolean;
  /** 編集フラグ */
  @Input() isEdit: boolean;
  /** 初期表示情報（新規）_検索結果 */
  @Input() newInitialhyojiInfo: Sgke141aResponseInitialhyojiInfo;
  /** 初期表示情報（訂正）_検索結果 */
  @Input() correctionInitialhyojiInfo: Sgke142aResponseInitialhyojiInfo;
  /** 画面表示情報（訂正）_検索結果 */
  @Input() gamenHyojiInfo: Sgke142aResponseGamenHyojiInfo;

  /** キャンセルボタン押下イベント*/
  @Output() cancelButtonClickEmitter = new EventEmitter();
  /** 削除ボタン押下イベント*/
  @Output() removeButtonClickEmitter = new EventEmitter();

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  /** 親フォーム情報 */
  private parentForm: UntypedFormGroup;

  /** 手数料報告登録APIリクエスト FormGroup */
  regInfFormGroup: UntypedFormGroup;

  /** 会社リスト */
  companyList: SelectBox[] = [];
  /** 入金地区リスト */
  rcvmnyAreaList: SelectBox[] = [];
  /** 入金口座リスト */
  rcvmnyKouzaList: SelectBox[] = [];
  /** 入金形態リスト */
  rcvmnyKeitaiList: SelectBox[] = [];
  /** 口座入金機関リスト */
  kouzaRcvmnyFcltList: SelectBox[] = [];

  /**
   * コンストラクタ
   * @param {UntypedFormBuilder} fb
   * @param {TimeApiService} timeApiService
   * @param {FormGroupDirective} parent
   */
  constructor(
    private fb: UntypedFormBuilder,
    public timeApiService: TimeApiService,
    private parent: FormGroupDirective
  ) {}

  /**
   * 初期処理
   * @memberof Sgke140dInfoComponent
   */
  ngOnInit(): void {
    this.parentForm = this.parent.form;

    if (this.isMordal) {
      // 登録/訂正の場合
      this.createCorrectionForm();
      this.setCorrectionSelectList();
    } else {
      // 新規登録の場合
      this.createNewForm();
      this.setNewSelectList();
      this.onChangeRcvmnyKeitai();
    }

    this.parentForm.addControl('reginf', this.regInfFormGroup);
  }

  /**
   * 購読解除
   * @memberof Sgke140dInfoComponent
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('reginf');
  }

  /**
   * 入力欄のデザイン切り替え
   * @param {string} ctrlName
   * @return {*}
   * @memberof Sgke140dInfoComponent
   */
  getAppearance(ctrlName: string) {
    const enabled = this.regInfFormGroup.controls[ctrlName]?.enabled;
    return enabled ? 'outline' : 'fill';
  }

  /**
   * 入金形態変更時処理
   * @memberof Sgke140dInfoComponent
   */
  onChangeRcvmnyKeitai(): void {
    // 入金形態の選択値取得
    const value = this.regInfFormGroup.controls['rcvmnyKeitaiCode'].value;
    // 入金形態リスト
    const parentList = this.newInitialhyojiInfo?.rcvmnyKeitaiCode;
    // 入金形態に紐づく口座入金機関取得
    const parent = parentList?.find((obj) => obj.codeValue.includes(value));
    const childList = parent?.kouzaRcvmnyBankofficecode;
    // 口座入金機関を口座入金機関コンボボックスに設定
    this.kouzaRcvmnyFcltList = childList?.map((child) => {
      let selectBox: SelectBox = {
        value: child.codeValue,
        viewValue: child.aname,
      };
      return selectBox;
    });

    let ctrl = this.regInfFormGroup.controls['kouzaRcvmnyBankofficecode'];
    // 入金形態が選択状態なら有効、未選択(=null)の場合は無効
    if (!this.isEdit && value) {
      ctrl.enable();
    } else {
      ctrl.disable();
    }
    ctrl.reset();

    this.updateFeeList();
  }

  /**
   * 手数料種別の更新
   *
   * @memberof Sgke140dInfoComponent
   */
  updateFeeList() {
    // 入金形態の選択値取得
    const rcvmnyKouza =
      this.regInfFormGroup.controls['rcvmnyKouzacode'].value;
    // 入金形態の選択値取得
    const rcvmnyKeitai =
      this.regInfFormGroup.controls['rcvmnyKeitaiCode'].value;
    // 入金形態の選択値取得
    const kouzaRcvmnyBankoffice =
      this.regInfFormGroup.controls['kouzaRcvmnyBankofficecode'].value;

    // 入金形態に紐づく手数料種類を取得 出力順並び替え
    const feeRegUnitList = this.newInitialhyojiInfo.feeRegUnit
      .filter((item) => {
        return (
          item.rcvmnyKouzacode == rcvmnyKouza &&
          item.rcvmnyKeitaiCode == rcvmnyKeitai &&
          item.kouzaRcvmnyBankofficecode == kouzaRcvmnyBankoffice
        );
      })
      .sort(
        (sourceObject, targetObject) =>
          sourceObject.outputOrder - targetObject.outputOrder
      );

    // 手数料内容設定
    this.feeCont = this.fb.array(
      feeRegUnitList.map((feeRegUnit) => {
        return this.fb.group({
          // 手数料種類コード
          feeCode: feeRegUnit.feeSyuruicode,
          // 手数料種類名称
          feeSyuruiAname: feeRegUnit.feeSyuruiAname,
          // 手数料額
          feeMny: this.fb.nonNullable.control(
            { value: null, disabled: false },
            Validators.required
          ),
        });
      })
    );
  }

  /**
   * キャンセルボタン押下時
   * @memberof Sgke140dInfoComponent
   */
  onClickCancel(): void {
    this.cancelButtonClickEmitter.emit();
  }

  /**
   * 削除ボタン押下時
   * @memberof Sgke140dInfoComponent
   */
  onClickRemove(): void {
    this.removeButtonClickEmitter.emit();
  }

  /**
   * 登録/訂正フォーム作成
   * @private
   * @memberof Sgke140dInfoComponent
   */
  private createCorrectionForm() {
    this.regInfFormGroup = this.fb.group({
      // 会社
      companycode: [
        { value: this.gamenHyojiInfo?.companycode, disabled: true },
        Validators.required,
      ],
      // 入金地区
      rcvmnyAreacode: [
        { value: this.gamenHyojiInfo?.rcvmnyAreacode, disabled: true },
        Validators.required,
      ],
      // 口座入金年月日
      kouzaRcvmnyDate: [
        {
          value: this.timeApiService.convertStringToDate(
            this.gamenHyojiInfo?.kouzaRcvmnyDate
          ),
          disabled: true,
        },
        Validators.required,
      ],
      // 入金口座
      rcvmnyKouzacode: [
        { value: this.gamenHyojiInfo?.rcvmnyKouzacode, disabled: true },
        Validators.required,
      ],
      // 入金形態
      rcvmnyKeitaiCode: [
        { value: this.gamenHyojiInfo?.rcvmnyKeitaiCode, disabled: true },
        Validators.required,
      ],
      // 口座入金機関
      kouzaRcvmnyBankofficecode: [
        {
          value: this.gamenHyojiInfo?.kouzaRcvmnyBankofficecode,
          disabled: true,
        },
        Validators.required,
      ],
      // 手数料種類/手数料額
      feeCont: this.fb.array([]),
    });

    // 手数料内容を出力順に並び替え
    const feeRegUnitList = this.gamenHyojiInfo.feeRegUnit.sort(
      (sourceObject, targetObject) =>
        sourceObject.outputOrder - targetObject.outputOrder
    );

    // 手数料内容設定
    this.feeCont = this.fb.array(
      feeRegUnitList.map((feeRegUnit) => {
        return this.fb.group({
          // 手数料明細管理番号
          feeMeisaiMno: this.fb.control({
            value: feeRegUnit.feeMeisaiMno,
            disabled: !this.isEdit,
          }),
          // 手数料コード
          feeCode: feeRegUnit.feeSyuruicode,
          // 手数料コード名称
          feeSyuruiAname: feeRegUnit.feeSyuruiAname,
          // 手数料金額
          feeMny: this.fb.nonNullable.control(
            { value: feeRegUnit.feeMny, disabled: false },
            Validators.required
          ),
        });
      })
    );
  }

  /**
   * 新規登録フォーム作成
   * @private
   * @memberof Sgke140dInfoComponent
   */
  private createNewForm() {
    this.regInfFormGroup = this.fb.group({
      // 会社
      companycode: this.fb.nonNullable.control(
        { value: null, disabled: false },
        Validators.required
      ),
      // 入金地区
      rcvmnyAreacode: this.fb.nonNullable.control(
        { value: null, disabled: false },
        Validators.required
      ),
      // 口座入金年月日
      kouzaRcvmnyDate: this.fb.nonNullable.control(
        { value: null, disabled: false },
        Validators.required
      ),
      // 入金口座
      rcvmnyKouzacode: this.fb.nonNullable.control(
        { value: null, disabled: false },
        Validators.required
      ),
      // 入金形態
      rcvmnyKeitaiCode: this.fb.nonNullable.control(
        { value: null, disabled: false },
        Validators.required
      ),
      // 口座入金機関
      kouzaRcvmnyBankofficecode: this.fb.nonNullable.control(
        { value: null, disabled: true },
        Validators.required
      ),
      // 手数料種類/手数料額
      feeCont: this.fb.array([]),
    });
  }

  /**
   * 選択リストに値を設定
   * @private
   * @memberof Sgke140dInfoComponent
   */
  private setCorrectionSelectList() {
    // 会社リスト
    let companySelectBox: SelectBox = {
      value: this.gamenHyojiInfo?.companycode,
      viewValue: this.gamenHyojiInfo?.company,
    };
    this.companyList.push(companySelectBox);

    // 入金地区リスト
    let rcvmnyAreaSelectBox: SelectBox = {
      value: this.gamenHyojiInfo?.rcvmnyAreacode,
      viewValue: this.gamenHyojiInfo?.rcvmnyArea,
    };
    this.rcvmnyAreaList.push(rcvmnyAreaSelectBox);

    // 入金口座リスト
    let rcvmnyKouzaSelectBox: SelectBox = {
      value: this.gamenHyojiInfo?.rcvmnyKouzacode,
      viewValue: this.gamenHyojiInfo?.rcvmnyKouza,
    };
    this.rcvmnyKouzaList.push(rcvmnyKouzaSelectBox);

    // 入金形態リスト
    let rcvmnyKeitaiSelectBox: SelectBox = {
      value: this.gamenHyojiInfo?.rcvmnyKeitaiCode,
      viewValue: this.gamenHyojiInfo?.rcvmnyKeitai,
    };
    this.rcvmnyKeitaiList.push(rcvmnyKeitaiSelectBox);

    // 口座入金機関
    let kouzaRcvmnyFcltSelectBox: SelectBox = {
      value: this.gamenHyojiInfo?.kouzaRcvmnyBankofficecode,
      viewValue: this.gamenHyojiInfo?.kouzaRcvmnyFclt,
    };
    this.kouzaRcvmnyFcltList.push(kouzaRcvmnyFcltSelectBox);
  }

  /**
   * 選択リストに値を設定
   * @private
   * @memberof Sgke140dInfoComponent
   */
  private setNewSelectList() {
    // 会社リスト
    const companycodeList = this.newInitialhyojiInfo?.companycode;
    this.companyList = companycodeList?.map((companycode) => {
      let selectBox: SelectBox = {
        value: companycode.codeValue,
        viewValue: companycode.aname,
      };
      return selectBox;
    });

    // 会社リスト1件目を選択
    this.regInfFormGroup.controls['companycode'].setValue(
      this.companyList[0].value
    );

    // 入金地区リスト
    // 会社に紐づく入金地区取得
    const companycode = companycodeList?.find((obj) =>
      obj.codeValue.includes(this.companyList[0].value)
    );
    const rcvmnyAreacodeList = companycode?.rcvmnyAreacode;
    // 入金地区を入金地区コンボボックスに設定
    this.rcvmnyAreaList = rcvmnyAreacodeList?.map((child) => {
      let selectBox: SelectBox = {
        value: child.codeValue,
        viewValue: child.aname,
      };
      return selectBox;
    });

    // 入金地区リスト1件目を選択
    this.regInfFormGroup.controls['rcvmnyAreacode'].setValue(
      this.rcvmnyAreaList[0].value
    );

    // 入金口座リスト
    this.rcvmnyKouzaList = this.newInitialhyojiInfo?.rcvmnyKouzacode?.map(
      (rcvmnyKouzacode) => {
        let selectBox: SelectBox = {
          value: rcvmnyKouzacode.codeValue,
          viewValue: rcvmnyKouzacode.aname,
        };
        return selectBox;
      }
    );

    // 入金形態リスト
    this.rcvmnyKeitaiList = this.newInitialhyojiInfo?.rcvmnyKeitaiCode?.map(
      (rcvmnyKeitai) => {
        let selectBox: SelectBox = {
          value: rcvmnyKeitai.codeValue,
          viewValue: rcvmnyKeitai.aname,
        };
        return selectBox;
      }
    );
  }

  /**
   * 手数料FormArray取得
   * @readonly
   * @type {FormArray}
   * @memberof Sgke140dInfoComponent
   */
  get feeCont() {
    return this.regInfFormGroup.get('feeCont') as FormArray;
  }

  /**
   * 手数料FormArray設定
   * @param {FormArray} feeContFormArray
   * @memberof Sgke140dInfoComponent
   */
  set feeCont(feeContFormArray: FormArray) {
    this.regInfFormGroup.setControl('feeCont', feeContFormArray);
  }
}
